import { RouterLink } from '../../generic/Link';

import styles from './SummaryActionLink.module.less';

type SummaryActionLinkProps = {
  to: string;
  action: string;
};

/**
 * Component for rendering an action option found on the new summary page.
 * This component does not handle actions other than router navigation.
 *
 * @param {object} params The parameters for the component
 * @param {string} params.to Where the user should be redirected to upon clicking the action button.
 * @param {string} params.action The button label.
 */
const SummaryActionLink = ({
  to,
  action,
}: SummaryActionLinkProps) =>
  <RouterLink to={to}>
    <span className={styles.container}>
      {action}
    </span>
  </RouterLink>;

export default SummaryActionLink;
